/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyGeneratorProperties
 */
export interface ProxyGeneratorProperties {
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsVideoBitrate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsVideoCrf?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsVideoVbr?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsAudioBitrate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsLut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsResolution?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsWatermark?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsTimecodeBurnIn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsAudioChannels?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsStagingPath?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProxyGeneratorProperties
     */
    supportsFilmstrip?: boolean;
}

export function ProxyGeneratorPropertiesFromJSON(json: any): ProxyGeneratorProperties {
    return ProxyGeneratorPropertiesFromJSONTyped(json, false);
}

export function ProxyGeneratorPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyGeneratorProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supportsVideoBitrate': !exists(json, 'supports_video_bitrate') ? undefined : json['supports_video_bitrate'],
        'supportsVideoCrf': !exists(json, 'supports_video_crf') ? undefined : json['supports_video_crf'],
        'supportsVideoVbr': !exists(json, 'supports_video_vbr') ? undefined : json['supports_video_vbr'],
        'supportsAudioBitrate': !exists(json, 'supports_audio_bitrate') ? undefined : json['supports_audio_bitrate'],
        'supportsLut': !exists(json, 'supports_lut') ? undefined : json['supports_lut'],
        'supportsResolution': !exists(json, 'supports_resolution') ? undefined : json['supports_resolution'],
        'supportsWatermark': !exists(json, 'supports_watermark') ? undefined : json['supports_watermark'],
        'supportsTimecodeBurnIn': !exists(json, 'supports_timecode_burn_in') ? undefined : json['supports_timecode_burn_in'],
        'supportsAudioChannels': !exists(json, 'supports_audio_channels') ? undefined : json['supports_audio_channels'],
        'supportsStagingPath': !exists(json, 'supports_staging_path') ? undefined : json['supports_staging_path'],
        'supportsFilmstrip': !exists(json, 'supports_filmstrip') ? undefined : json['supports_filmstrip'],
    };
}

export function ProxyGeneratorPropertiesToJSON(value?: ProxyGeneratorProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supports_video_bitrate': value.supportsVideoBitrate,
        'supports_video_crf': value.supportsVideoCrf,
        'supports_video_vbr': value.supportsVideoVbr,
        'supports_audio_bitrate': value.supportsAudioBitrate,
        'supports_lut': value.supportsLut,
        'supports_resolution': value.supportsResolution,
        'supports_watermark': value.supportsWatermark,
        'supports_timecode_burn_in': value.supportsTimecodeBurnIn,
        'supports_audio_channels': value.supportsAudioChannels,
        'supports_staging_path': value.supportsStagingPath,
        'supports_filmstrip': value.supportsFilmstrip,
    };
}


